/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'dui7Wd7FyHr8n8EqmZKA2M.png': { uri: '/images/dui7Wd7FyHr8n8EqmZKA2M.png' },
'sTmsM8Jbwkus8V1HyDMzZm.png': { uri: '/images/sTmsM8Jbwkus8V1HyDMzZm.png' },
'aLTD7gafRskjYH5nWBNBJT.png': { uri: '/images/aLTD7gafRskjYH5nWBNBJT.png' },
'7UhkSVpGuNrLednfnUiCF1.png': { uri: '/images/7UhkSVpGuNrLednfnUiCF1.png' },
'8C7KMneUBhhfuD4YE2a7re.png': { uri: '/images/8C7KMneUBhhfuD4YE2a7re.png' },
'oE7PbDxZ9ERzZLSbkRnxFz.png': { uri: '/images/oE7PbDxZ9ERzZLSbkRnxFz.png' },
'hibH1CoucBX6WmsZWascgE.png': { uri: '/images/hibH1CoucBX6WmsZWascgE.png' },
'kQTcbJqVeKpcbQXDdcmu9K.png': { uri: '/images/kQTcbJqVeKpcbQXDdcmu9K.png' },
'rqt43jWfrADfocLhSNdbtn.png': { uri: '/images/rqt43jWfrADfocLhSNdbtn.png' },
'sP9Un6E2NpwuVg3nBc8dKY.png': { uri: '/images/sP9Un6E2NpwuVg3nBc8dKY.png' },
'cz2HGRjTRfKtWkxCMhrAKt.png': { uri: '/images/cz2HGRjTRfKtWkxCMhrAKt.png' },
'm9qH1oa6Vtoteoes3uTpJV.png': { uri: '/images/m9qH1oa6Vtoteoes3uTpJV.png' },
'3cfNJdQphFGJX98889Xwah.png': { uri: '/images/3cfNJdQphFGJX98889Xwah.png' },
'p8Dj9jmC5iuVaDs31uX8mS.png': { uri: '/images/p8Dj9jmC5iuVaDs31uX8mS.png' },
'qZ7kL3YvbnnEx3FRtkwWcZ.png': { uri: '/images/qZ7kL3YvbnnEx3FRtkwWcZ.png' },
'cbThWG4zkMticQFYNfMvpS.png': { uri: '/images/cbThWG4zkMticQFYNfMvpS.png' },
'nXkCJjLFmrwmSR1BZuMvPA.png': { uri: '/images/nXkCJjLFmrwmSR1BZuMvPA.png' },
'9Wpr75Q2mMWP7PAJtegWK3.webp': { uri: '/images/9Wpr75Q2mMWP7PAJtegWK3.webp' },
'ohETtMdceUSGhtcGc3F62M.png': { uri: '/images/ohETtMdceUSGhtcGc3F62M.png' },
'7W7qh61RSnwzSshLhcvxsh.png': { uri: '/images/7W7qh61RSnwzSshLhcvxsh.png' },
'ujFQFMfG1V5DTuVoncM5yh.png': { uri: '/images/ujFQFMfG1V5DTuVoncM5yh.png' },
'8Ze27SVrNaQ4BzL32W1cbA.png': { uri: '/images/8Ze27SVrNaQ4BzL32W1cbA.png' },
'p9Vdp3wutsnu9ENF1ahoZa.png': { uri: '/images/p9Vdp3wutsnu9ENF1ahoZa.png' },
'7mswcxJ3JisbXY1xfaA6w5.png': { uri: '/images/7mswcxJ3JisbXY1xfaA6w5.png' },
'vWqhLTsU3KMK2gXQLmNsS1.png': { uri: '/images/vWqhLTsU3KMK2gXQLmNsS1.png' },
'2QyDhrLCPBs3af7ss4p7ii.png': { uri: '/images/2QyDhrLCPBs3af7ss4p7ii.png' },
'5zLhMFtLYrYDqn8T26aPPw.png': { uri: '/images/5zLhMFtLYrYDqn8T26aPPw.png' },
'rQT4c8ZKSyFGJRroXqvs2v.png': { uri: '/images/rQT4c8ZKSyFGJRroXqvs2v.png' },
'ciNP9hKjm9sFYUfkPAqd9S.png': { uri: '/images/ciNP9hKjm9sFYUfkPAqd9S.png' },
'8xkMkHPp5nDPeJPHSRVs1P.png': { uri: '/images/8xkMkHPp5nDPeJPHSRVs1P.png' },
'3vwuFtaijTSjyMu3uNkGn1.png': { uri: '/images/3vwuFtaijTSjyMu3uNkGn1.png' },
'oiSJG996MbPNo9g4V5kAYs.png': { uri: '/images/oiSJG996MbPNo9g4V5kAYs.png' },
'gv9hcmSXV2mKaDZnYThLGs.png': { uri: '/images/gv9hcmSXV2mKaDZnYThLGs.png' },
'2kFWQGagbKrYk4hUDeXs73.png': { uri: '/images/2kFWQGagbKrYk4hUDeXs73.png' },
'hTBeLGK5MnhgE2i5uQMEYE.png': { uri: '/images/hTBeLGK5MnhgE2i5uQMEYE.png' },
'oG1uxnwGTfFvzpRFGPyYtM.png': { uri: '/images/oG1uxnwGTfFvzpRFGPyYtM.png' },
'fy98ZL5wbBH1DXZDg72fci.png': { uri: '/images/fy98ZL5wbBH1DXZDg72fci.png' },
'rxhot7skK3QEMeGBAYMWCY.png': { uri: '/images/rxhot7skK3QEMeGBAYMWCY.png' }
}

export default imageStaticSourcesByFileName
